<template>
  <div ref="LvDataTable" class="lv-template-data-table">
    <div class="lv-template-data-table__title-wrap">
      <LvText
        v-if="title || setTitle"
        bold
        :h2="titleSize === 'h2'"
        :h3="titleSize === 'h3'"
        :h4="titleSize === 'h4'"
        :h5="titleSize === 'h5'"
        :h6="titleSize === 'h6'"
        class="mb-20"
      >
        {{ $t(_title) }}
      </LvText>
      <div ref="titleButton" class="lv-template-data-table__title-right">
        <slot name="titleButton" />
        <div v-if="isCreatable && _scopeCreateBtn" class="button mb-20">
          <WsButton001
            narrow
            :isloading="isLoading.content || isLoading.filter || isLoading.parentApi"
            @click="$_onCreate()"
          >
            {{ $t('新增') }}
          </WsButton001>
        </div>
        <div v-for="(btn, btnIndex) in customBtnList" :key="btnIndex" class="button mb-20">
          <WsButton001
            narrow
            :isloading="isLoading.content || isLoading.filter || isLoading.parentApi"
            @click="$_onClickCustomBtn(btn.value)"
          >
            {{ $t(btn.text) }}
          </WsButton001>
        </div>
      </div>
    </div>
    <WsRow v-if="filterFieldTypes" isCenter class="mb-20" :style="{ 'z-index': filterZIndex }">
      <AppFilterBar
        v-if="!isLoading.filter"
        v-model="filterState"
        btns
        :filter-fields="filterFields"
        :scroll="scroll"
      >
        <template v-slot:front-custom-filters>
          <slot name="frontCustomFilters" />
        </template>
        <template v-slot:btns>
          <slot name="filterBtns" :filterState="filterState" />
        </template>
      </AppFilterBar>
    </WsRow>
    <LvTabs
      v-if="_tabs && _tabs.items && _tabs.items.length"
      :items="_tabs.items"
      :value="_tabs.selectedTabId"
      :isDisabled="isLoading.content || isLoading.parentApi"
      :isLoading="isLoading.content || isLoading.parentApi"
      class="mb-20"
      @input="$_onClickContentTab($event)"
    />
    <slot
      v-if="!isLoading.content && !isLoading.filter && !isLoading.parentApi"
      name="section"
      :isLoading="isLoading.content && isLoading.filter && isLoading.parentApi"
    />
    <LvFlexBox
      v-if="
        isDeletableAll &&
        !isLoading.content &&
        !isLoading.filter &&
        !isLoading.parentApi &&
        listData.length
      "
      alignItems="center"
      class="ml-10 mb-12"
    >
      <LvText h5 :class="{ 'mr-16': isDeletableAll }">
        {{ $t('{number}項已選取', { number: selectedItemList.length }) }}
      </LvText>
      <WsButton001 red shortButton @click="$emit('delete-all', selectedItemList)">
        {{ $t('刪除') }}
      </WsButton001>
    </LvFlexBox>
    <div>
      <LlEmptyPic
        v-if="
          listData.length === 0 &&
          !isLoading.content &&
          !isLoading.filter &&
          !hideEmptyPic &&
          !isLoading.parentApi
        "
        title="目前尚無資料"
        :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
      />
      <slot
        v-else
        name="content"
        :listData="listData"
        :isLoading="isLoading.content || isLoading.parentApi"
      >
        <DotLoading v-if="isLoading.content || isLoading.parentApi" />
        <div v-else-if="hidePagination">
          <DataTable
            :disable="disable"
            :isloading="isLoading.content || isLoading.parentApi"
            :column-header="columnHeader"
            :row-data="listData"
            :mobileCardLayoutEnabled="mobileCardLayoutEnabled"
            @btn-click="$_onClickBtn($event)"
            @click="$_onClickItem($event)"
            @data-click="$emit('data-click', $event)"
            @row-checkbox-onclick="$_onClickCheckbox($event)"
            @click-icon="$_onClickIcon($event)"
            @menu-item-click="$emit('menu-item-click', $event)"
            @button-click="$emit('button-click', $event)"
            @click-icon-btn="$emit('click-icon-btn', $event)"
            @check="$_onToggleSelect($event)"
            @click-icon-nav-drawer="$emit('click-icon-nav-drawer', $event)"
          >
            <template v-slot:columnHeader="{ columnHeaderItem }">
              <slot name="columnHeader" :columnHeaderItem="columnHeaderItem" />
            </template>
            <template v-slot="{ rowItem, columnHeaderItem }">
              <slot name="item" :rowItem="rowItem" :columnHeaderItem="columnHeaderItem" />
            </template>
          </DataTable>
        </div>
        <div v-else>
          <LlPaginateList
            :isloading="isLoading.content || isLoading.parentApi"
            :page-count="paginate.lastPage"
            :page-range="3"
            :margin-pages="3"
            :first-button-text="_paginationFirstButtonText"
            :last-button-text="_paginationLastButtonText"
            :prev-text="_paginationPrevText"
            :next-text="_paginationNextText"
            :container-class="'pagination'"
            first-last-button
            :page="paginate.ingPage"
            :from-data-num="paginate.fromDataNum"
            :to-data-num="paginate.toDataNum"
            :total-data-num="paginate.totalDataNum"
            :mobileCardLayoutEnabled="mobileCardLayoutEnabled"
            @input="$_onChangePage($event)"
          >
            <DataTable
              :disable="disable"
              :isloading="isLoading.content || isLoading.parentApi"
              :column-header="columnHeader"
              :row-data="listData"
              :mobileCardLayoutEnabled="mobileCardLayoutEnabled"
              @btn-click="$_onClickBtn($event)"
              @click="$_onClickItem($event)"
              @data-click="$emit('data-click', $event)"
              @row-checkbox-onclick="$_onClickCheckbox($event)"
              @click-icon="$_onClickIcon($event)"
              @menu-item-click="$emit('menu-item-click', $event)"
              @button-click="$emit('button-click', $event)"
              @click-icon-btn="$emit('click-icon-btn', $event)"
              @check="$_onToggleSelect($event)"
              @click-icon-nav-drawer="$emit('click-icon-nav-drawer', $event)"
              @check-all="$_onToggleCheckAll($event)"
            >
              <template v-slot:columnHeader="{ columnHeaderItem }">
                <slot name="columnHeader" :columnHeaderItem="columnHeaderItem" />
              </template>
              <template v-slot="{ rowItem, columnHeaderItem }">
                <slot name="item" :rowItem="rowItem" :columnHeaderItem="columnHeaderItem" />
              </template>
            </DataTable>
          </LlPaginateList>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import S_scope from '@/service/api/v1/scope';
import S_base from '@/__vue2stone/service/wasaapi/v1/__base';
import H_filter from '@/helpers/filter';
import S_factoryTag from '@/service/api/v1/factory_tag';
import H_factoryTag from '@/helpers/factoryTag';
import H_systemClassMenu from '@/helpers/systemClassMenu';
import S_guidelineStatus from '@/service/api/v1/guidelineStatus';

export default {
  props: {
    title: {
      type: String,
    },
    titleSize: {
      type: String,
      default: 'h2',
    },
    fetchUrl: {
      type: String,
    },
    createUrl: {
      type: String,
    },
    createScopes: {
      type: [Array, String],
    },
    setListData: {
      type: Function,
    },
    filterFieldTypes: {
      type: Array,
    },
    columnHeader: {
      type: Array,
    },
    setParams: {
      type: Function,
    },
    onlyDisplayCollect: {
      type: Boolean,
      default: false,
    },
    isScrollFetch: {
      type: Boolean,
      default: false,
    },
    isCreatable: {
      type: Boolean,
      default: false,
    },
    isFilterFieldTypeChange: {
      type: Boolean,
      default: false,
    },
    setFetchUrl: {
      type: Function,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    tabs: {
      type: Object,
    },
    setTitle: {
      type: Function,
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
    hideEmptyPic: {
      type: Boolean,
      default: false,
    },
    scroll: {
      type: Number,
    },
    customBtnList: {
      type: Array,
    },
    parentData: {
      type: Object,
    },
    isDeletableAll: {
      type: Boolean,
      default: false,
    },
    filterZIndex: {
      type: String,
    },
    mobileCardLayoutEnabled: {
      type: Boolean,
      default: false,
    },
    fetchTabAmountUrl: {
      type: String,
    },
    setTabAmountParams: {
      type: Function,
    },
    setTabAmountListData: {
      type: Function,
    },
  },
  data() {
    return {
      paginate: {
        lastPage: 1,
        ingPage: 1,
        fromDataNum: 0,
        toDataNum: 0,
        totalDataNum: 0,
      },
      isLoading: {
        content: false,
        filter: false,
        fetchUrl: false,
        parentApi: false,
      },
      filterState: {},
      filterFields: [],
      listData: [],
      isInitFilter: false,
      isMounted: false,
      cancelTokenSource: null,
      selectedItemList: [],
      tabItems: [],
    };
  },
  computed: {
    _systemClasses() {
      if (!this.$store.state.model.systemClasses) {
        return [];
      } else {
        return this.$store.state.model.systemClasses;
      }
    },
    _systemClassesMenu() {
      const list = JSON.parse(JSON.stringify(this._systemClasses));
      return H_systemClassMenu.mapSystemClassRowsForStateDropdownSelectClassification(
        list,
        'system_subclasses',
      );
    },
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _paginationPrevText() {
      return '<i class="icon-chevron-back" />';
    },
    _paginationNextText() {
      return '<i class="icon-chevron-forward" />';
    },
    _paginationFirstButtonText() {
      return '<i class="icon-chevron-back-start" />';
    },
    _paginationLastButtonText() {
      return '<i class="icon-chevron-forward-end" />';
    },
    _scopeCreateBtn() {
      return typeof this.createScopes === 'string' && this.parentData
        ? S_scope.isMultiScopeAndUserAvailable(this.createScopes, this.parentData)
        : S_scope.$_isAvailable(this.createScopes);
    },
    _tabs() {
      if (!this.tabs) {
        return {
          items: [],
          selectedTabId: null,
        };
      }
      return {
        items: this.fetchTabAmountUrl ? this.tabItems : this.tabs.items,
        selectedTabId: this.tabs.selectedTabId,
      };
    },
    _title() {
      if (this.setTitle) {
        return this.setTitle(this.listData);
      } else {
        return this.title;
      }
    },
    _id() {
      return this.$route.query.id;
    },
  },
  watch: {
    _systemClasses: {
      async handler(newVal) {
        if (this.filterFieldTypes && newVal.length) {
          for (let i = 0; i < this.filterFieldTypes.length; i++) {
            const type = this.filterFieldTypes[i];
            if (type.name === 'systemSubclasses') {
              await this.$_setFilter();
            }
          }
        }
      },
    },
    filterState: {
      async handler(newVal, oldVal) {
        this.$emit('filter-state-change', this.filterState);
        if (!this.isInitFilter || !this.isMounted) return;
        let shouldRefetch = false;
        for (let key in newVal) {
          const newValItem = newVal[key];
          const oldValItem = oldVal[key];
          if (newValItem !== oldValItem && oldValItem !== undefined) {
            const tarFieldTypeHasParentFilter = this.filterFieldTypes.find(
              type => type.parentFilter && type.parentFilter.includes(key),
            );
            if (tarFieldTypeHasParentFilter) {
              const tarFieldIndex = this.filterFields.findIndex(
                field => field.name === tarFieldTypeHasParentFilter.name,
              );
              this.filterFields[tarFieldIndex].items = await tarFieldTypeHasParentFilter.getItems(
                this.filterState,
              );
              this.filterState[tarFieldTypeHasParentFilter.name] = null;
            } else {
              shouldRefetch = true;
            }
          }
        }
        if (shouldRefetch) {
          if (this.isLoading.fetchUrl) return;
          this.$_syncSubclassFilterToQuery();
          this.paginate.ingPage = 1;
          await this.$_setTabAmount();
          await this.$_getListData();
        }
      },
      deep: true,
    },
    fetchUrl: {
      async handler() {
        this.isLoading.fetchUrl = true;
        this.$_onChangeIsLoading('content', true);
        this.listData = [];
        if (this.isFilterFieldTypeChange) {
          await this.$_setFilter();
          this.$_syncSubclassFilterToQuery();
        } else {
          this.filterState = this.$_initFilterState();
        }
        await this.$_setTabAmount();
        this.paginate.ingPage = 1;
        await this.$_getListData();
        this.$_onChangeIsLoading('content', false);
        this.isLoading.fetchUrl = false;
      },
    },
    '_tabs.selectedTabId': {
      async handler() {
        if (!this.isMounted || this.isLoading.fetchUrl) return;
        this.paginate.ingPage = 1;
        await this.$_getListData();
      },
    },
    _id: {
      async handler() {
        this.filterState = this.$_initFilterState();
        await this.$_getListData();
      },
    },
  },
  async mounted() {
    this.cancelTokenSource = this.$axios.CancelToken.source();
    await this.$_init();
  },
  beforeDestroy() {
    this.cancelTokenSource.cancel('destroy');
  },
  methods: {
    async $_init() {
      this.$_onChangeIsLoading('content', true);
      await this.$_setFilter();
      await this.$_setTabAmount();
      this.isInitFilter = true;
      this.$_syncSubclassFilterToQuery();
      await this.$_getListData();
      this.isMounted = true;
      this.$_onChangeIsLoading('content', false);
    },
    async $_getListData(isScroll) {
      if (!this.isInitFilter || (this.filterFieldTypes && !this.filterState)) return;
      const fetchObj = this.$_getFetchObj();
      if (!fetchObj.url) {
        this.listData = [];
        return;
      }
      if (this.isScrollFetch && !isScroll) this.listData = [];
      this.$_onChangeIsLoading('content', true);
      const res = await S_base.index(fetchObj);
      let newListData = res.data.length
        ? this.setListData
          ? this.setListData(res.data, this.filterState, this.tabs ? this.tabs.selectedTabId : null)
          : res.data
        : [];
      newListData = this.$_checkSelection(newListData);
      if (this.isScrollFetch) {
        this.listData = isScroll ? [...this.listData, ...newListData] : newListData;
      } else {
        this.listData = newListData;
      }
      if (res.meta) {
        this.paginate.lastPage = res.meta.last_page;
        this.paginate.ingPage = res.meta.current_page
          ? res.meta.current_page
          : this.paginate.ingPage;
        this.paginate.fromDataNum = res.meta.from;
        this.paginate.toDataNum = res.meta.to;
        this.paginate.totalDataNum = res.meta.total;
      } else {
        this.paginate.fromDataNum = 1;
        this.paginate.toDataNum = newListData.length;
        this.paginate.totalDataNum = newListData.length;
      }
      this.$emit('fetch-data', this.listData);
      this.$_onChangeIsLoading('content', false);
    },
    async $_initFilterFields() {
      if (!this.filterFieldTypes) return [];
      const filterFields = H_filter.getFields(this.filterFieldTypes);
      for (let field of filterFields) {
        if (
          field.name === 'systemSubclasses' &&
          field.type === 'two-layer-dropdown' &&
          this._systemClasses.length
        ) {
          field.items = this._systemClassesMenu;
          field.defaultValue = H_systemClassMenu.getLeafIdsFromClassificationMenu(field.items);
        }
        if (field.name === 'factorySystemClasses' && field.type === 'two-layer-dropdown') {
          field.items = await H_systemClassMenu.fetchFactorySystemClassMenuForClassification();
          field.defaultValue = H_systemClassMenu.getLeafIdsFromClassificationMenu(field.items);
        }
        if (field.name === 'factoryTags' && field.type === 'one-layer-dropdown') {
          field.items = await this.$_getTagList();
        }
        if (field.name === 'guidelineStatus' && field.type === 'one-layer-dropdown') {
          field.items = await this.$_getGuidelineStatus();
        }
        if (field.getItems) {
          field.items = await field.getItems(this.filterState);
        }
        if (field.getDefaultVal) {
          field.defaultValue = await field.getDefaultVal(field.items);
        }
      }
      return filterFields;
    },
    $_initFilterState() {
      if (!this.filterFields.length) return {};
      const state = H_filter.initState(this.filterFields, this.$route.query);
      this.filterFields.forEach(field => {
        if (H_systemClassMenu.isSubclassFilterFieldName(field.name)) {
          state[field.name] = H_systemClassMenu.resolveSubclassSelectionFromQuery(
            this.$route.query[field.name],
            field.items,
          );
        }
      });
      return state;
    },
    $_mergeSubclassFilterState(prevState) {
      const state = { ...(prevState || {}) };
      this.filterFields.forEach(field => {
        if (!H_systemClassMenu.isSubclassFilterFieldName(field.name)) return;
        const prev = prevState?.[field.name];
        state[field.name] =
          prev?.length > 0
            ? H_systemClassMenu.intersectSubclassSelection(prev, field.items)
            : H_systemClassMenu.getLeafIdsFromClassificationMenu(field.items);
      });
      this.filterFields.forEach(field => {
        if (state[field.name] === undefined) {
          state[field.name] = field.defaultValue !== undefined ? field.defaultValue : null;
        }
      });
      return state;
    },
    $_getSubclassFilterFieldsForQuery() {
      return this.filterFields
        .filter(
          field =>
            field.type === 'two-layer-dropdown' &&
            H_systemClassMenu.isSubclassFilterFieldName(field.name),
        )
        .map(field => ({
          queryKey: field.name,
          selectedIds: this.filterState[field.name],
          menu: field.items,
        }));
    },
    $_syncSubclassFilterToQuery() {
      const subclassFields = this.$_getSubclassFilterFieldsForQuery();
      if (!subclassFields.length) return;
      const query = H_systemClassMenu.applySubclassFieldsToRouteQuery(
        this.$route.query,
        subclassFields,
      );
      const isSame = !subclassFields.some(
        ({ queryKey }) => (this.$route.query[queryKey] || '') !== (query[queryKey] || ''),
      );
      if (isSame) return;
      this.$router.replace({ query }).catch(() => {});
    },
    async $_setFilter() {
      this.$_onChangeIsLoading('filter', true);
      const prevState = this.isInitFilter ? { ...this.filterState } : null;
      this.filterFields = await this.$_initFilterFields();
      this.filterState = this.isInitFilter
        ? this.$_mergeSubclassFilterState(prevState)
        : this.$_initFilterState();
      if (this.isInitFilter && this.isMounted) {
        this.$_syncSubclassFilterToQuery();
      }
      this.$_onChangeIsLoading('filter', false);
    },
    $_onCreate() {
      if (this.createUrl) {
        this.$router.push({
          path: this.createUrl,
          query: this.$route.query,
        });
      } else {
        this.$emit('create');
      }
    },
    $_onClickItem($event) {
      if (this.disable) return;
      this.$emit('click-item', $event);
    },
    async $_onChangePage($event) {
      this.paginate.ingPage = $event;
      this.$emit('page-change');
      await this.$_getListData();
    },
    $_onClickCheckbox($event) {
      const rowIndex = $event.rowIndex;
      this.$emit('click-checkbox', this.listData[rowIndex]);
      if (this.onlyDisplayCollect) {
        this.listData.splice(rowIndex, 1);
      } else {
        this.listData[rowIndex].isCollected = !this.listData[rowIndex].isCollected;
      }
    },
    $_onClickBtn($event) {
      this.$emit('click-btn', $event);
    },
    async $_getTagList() {
      const params = {
        order_by: 'sequence',
        order_way: 'asc',
        get_all: 1,
      };
      const res = await S_factoryTag.index(params);
      return H_factoryTag.setItems(res);
    },
    $_getFetchObj() {
      const params = this.$_getParams();
      let fetchObj = {};
      if (this.setFetchUrl) {
        fetchObj = this.setFetchUrl(this.filterState);
      } else if (this.fetchUrl) {
        fetchObj = { url: this.fetchUrl };
      }
      fetchObj = {
        ...fetchObj,
        params,
        pagination: true,
        cancelTokenSource: this.cancelTokenSource,
      };
      return fetchObj;
    },
    $_getParams() {
      let params = {};
      if (this.setParams) {
        params = this.setParams(this.filterState, this._tabs.selectedTabId);
      } else {
        params = this.filterState;
      }
      if (!params.get_all) {
        params = {
          ...params,
          page: this.paginate.ingPage,
        };
      }
      return {
        ...this.$axios.defaults.params,
        ...params,
      };
    },
    $_onClickIcon($event) {
      this.$emit('click-icon', $event);
    },
    $_onChangeIsLoading(type, value) {
      this.isLoading[type] = value;
      this.$emit('loading', { type, value });
    },
    $_onClickContentTab($event) {
      if (this.isLoading.content || this.isLoading.filter || this.isLoading.parentApi) return;
      const id = $event.id;
      this.$emit('click-tab', id);
    },
    $_onClickCustomBtn(value) {
      this.$emit('click-custom-btn', value);
    },
    $_resetSelectedItemList() {
      this.selectedItemList = [];
    },
    $_onToggleSelect($event) {
      this.$emit('check', $event);
      const { item, isChecked } = $event;
      const tarListDataIndex = this.listData.findIndex(_item => _item.id === item.id);
      if (isChecked) {
        this.selectedItemList.push(item);
        this.listData[tarListDataIndex].isChecked = true;
      } else {
        const tarIndex = this.selectedItemList.findIndex(_item => _item.id === item.id);
        this.selectedItemList.splice(tarIndex, 1);
        this.listData[tarListDataIndex].isChecked = false;
      }
    },
    $_checkSelection(newListData) {
      if (!this.selectedItemList.length) return newListData;
      return newListData.map(item => {
        if (!this.selectedItemList.some(_item => _item.id === item.id)) return item;
        return { ...item, isChecked: true };
      });
    },
    $_onToggleCheckAll($event) {
      if ($event === true) {
        this.listData.forEach(data => {
          if (!this.selectedItemList.some(item => item.id === data.id))
            this.selectedItemList.push(data);
          data.isChecked = true;
        });
      } else {
        this.listData.forEach(data => {
          if (!data.isChecked) return;
          const tarIndex = this.selectedItemList.findIndex(item => item.id === data.id);
          this.selectedItemList.splice(tarIndex, 1);
          data.isChecked = false;
        });
      }
    },
    async $_getGuidelineStatus() {
      const params = {
        order_by: 'sequence',
        order_way: 'asc',
        get_all: 1,
      };
      const res = await S_guidelineStatus.index(params);
      return H_factoryTag.setItems(res);
    },
    async $_setTabAmount() {
      if (!this.fetchTabAmountUrl) return;
      const params = this.setTabAmountParams ? this.setTabAmountParams(this.filterState) : {};
      const res = await S_base.index({ url: this.fetchTabAmountUrl, params });
      this.tabItems = this.setTabAmountListData(this.tabs.items, res);
    },
  },
};
</script>
